import { defineItemStore } from "../itemStore.store";
import { cloneDeep } from "lodash-es";
import type { ImpactMatrix } from "./ImpactMatrix";

export const defaultImpactMatrix: ImpactMatrix = {
  type: "impactMatrix",
  elementUids: [],
  title: "",
  description: "",

  allTargets: false,
  allResources: false,
  allIndices: false,

  relationType: "impact",

  id: 0,
  uid: "impactMatrix_0",
  createdAt: 0,
};

export const useImpactMatrixStore = defineItemStore("model/impactMatrices", defaultImpactMatrix, {
  state: (baseState) => {
    // create a default impact matrix
    baseState.count += 1;
    baseState.items[0] = {
      ...cloneDeep(defaultImpactMatrix),
      id: 0,
      uid: "impactMatrix_0",
      allTargets: true,
      createdAt: Date.now()
    }
    baseState.order = [0];

    return {
      ...baseState,
      selectedMatrixId: 0 as number | null
    };
  },

  getters: {
    selectedMatrix: (state): ImpactMatrix | undefined => {
      return state.items[state.selectedMatrixId];
    }
  },

  actions: {
    async new(data: Partial<ImpactMatrix>) {
      const matrix = await this.create(data);

      this.selectedMatrixId = matrix.id;

      console.log("select matrix", matrix.id);

      return matrix;
    },

    selectMatrix(id: number) {
      this.selectedMatrixId = id;
    }
  },
  events: {
    async afterDelete(matrix) {
      if (this.selectedMatrixId == matrix.id) {
        if (this.order.length == 0) {
          this.selectedMatrixId = null;
        } else {
          this.selectedMatrixId = this.order[0];
        }
      }
    }
  }
});